import './event.css';

import { domain, main_domain, ogImage } from 'config';
import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Content from '../../components/card';

import { getEvent, getEventIdle } from 'store/ducks/event/actions';
import { selectorCards } from 'store/ducks/event/selector';
import Card from 'components/card/card';
import { useParams } from 'react-router-dom';

import Node from '../../components/card/component/node';
import ServiceCard from 'components/service_card';
import StoryCard from 'components/story_card';

import Masonry from 'react-masonry-component';
import { Helmet } from 'react-helmet';

type Props = {};

const VideoItem = ({ src = '', id = '' }: { src?: any; id?: any }) => {
    const [play, setPlay] = useState(false);

    const videoRef = useRef(null);

    return (
        <div className="section__grid-item _video">
            <video ref={videoRef} src={src} id={id} loop={true}></video>
            <a
                href="#"
                className={`section__grid-item-play ${(play && '_play') || ''}`}
                onClick={e => {
                    e.preventDefault();

                    setPlay(!play);

                    console.log(videoRef.current.paused);

                    if (videoRef && videoRef.current) {
                        if (videoRef.current.paused) {
                            videoRef.current.play();
                        } else {
                            videoRef.current.pause();
                        }
                    }
                }}
            >
                {(play && (
                    <svg
                        width="30"
                        height="50"
                        viewBox="0 0 30 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            x="0.25"
                            width="7.5"
                            height="50"
                            rx="2.5"
                            fill="#fff"
                        />
                        <rect
                            x="22.25"
                            width="7.5"
                            height="50"
                            rx="2.5"
                            fill="#fff"
                        />
                    </svg>
                )) || (
                    <svg
                        fill="#fff"
                        height="50px"
                        width="50px"
                        viewBox="0 0 58.752 58.752"
                    >
                        <g>
                            <path
                                d="M52.524,23.925L12.507,0.824c-1.907-1.1-4.376-1.097-6.276,0C4.293,1.94,3.088,4.025,3.088,6.264v46.205
                                c0,2.24,1.204,4.325,3.131,5.435c0.953,0.555,2.042,0.848,3.149,0.848c1.104,0,2.192-0.292,3.141-0.843l40.017-23.103
                                c1.936-1.119,3.138-3.203,3.138-5.439C55.663,27.134,54.462,25.05,52.524,23.925z M49.524,29.612L9.504,52.716
                                c-0.082,0.047-0.18,0.052-0.279-0.005c-0.084-0.049-0.137-0.142-0.137-0.242V6.263c0-0.1,0.052-0.192,0.14-0.243
                                c0.042-0.025,0.09-0.038,0.139-0.038c0.051,0,0.099,0.013,0.142,0.038l40.01,23.098c0.089,0.052,0.145,0.147,0.145,0.249
                                C49.663,29.47,49.611,29.561,49.524,29.612z"
                            />
                        </g>
                    </svg>
                )}
            </a>
        </div>
    );
};

const Event = (props: Props) => {
    const { slug }: any = useParams();

    const dispatch = useDispatch();

    const { status, data }: any = useSelector(
        (state: { event: any }) => state.event
    );
    const collectionsPosts = useSelector(
        (state: any) => state.homepage.collectionsPosts
    );

    const cards = useSelector(selectorCards);

    useEffect(() => {
        if (status == 'IDLE') {
            dispatch(
                getEvent({
                    slug: slug,
                })
            );
        }
    }, [slug]);

    useEffect(() => {
        if (status == 'SUCCESS') {
            dispatch(getEventIdle());
        }
    }, [status]);

    useEffect(() => {
        if (status == 'IDLE') {
            dispatch(
                getEvent({
                    slug: slug,
                })
            );
        }
    }, []);

    const handleScrollAnchor = (e: any, index: any) => {
        e.preventDefault();

        window.scrollTo({
            top:
                document
                    .querySelectorAll('.page__content .card')
                    [index].getBoundingClientRect().top + window.scrollY,
            behavior: 'smooth',
        });
    };

    return (
        <>
            <Helmet>
                <meta
                    property="og:url"
                    content={main_domain + '/events/' + slug}
                />
                <meta property="og:type" content="page" />
                <title>
                    {(data &&
                        data.attributes &&
                        ((data.attributes.OG_Title &&
                            data.attributes.OG_Title) ||
                            data.attributes.Title)) ||
                        ''}
                </title>
                <meta
                    name="description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                ></meta>
                <meta
                    property="og:title"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Title &&
                                data.attributes.OG_Title) ||
                                data.attributes.Title)) ||
                        ''
                    }
                />
                <meta
                    property="og:description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                />
                <meta
                    property="og:image"
                    content={
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta
                    property="vk:image"
                    content={
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="vk:image:width" content="537" />
                <meta property="vk:image:height" content="240" />
                <meta
                    property="twitter:image"
                    content={
                        (data &&
                            data.attributes &&
                            data.attributes.OG_Image &&
                            data.attributes.OG_Image.data &&
                            domain +
                                data.attributes.OG_Image.data.attributes.url) ||
                        ogImage
                    }
                />
                <meta property="twitter:image:width" content="1024" />
                <meta property="twitter:image:height" content="512" />
                <meta
                    name="twitter:title"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Title &&
                                data.attributes.OG_Title) ||
                                data.attributes.Title)) ||
                        ''
                    }
                />
                <meta
                    name="twitter:description"
                    content={
                        (data &&
                            data.attributes &&
                            ((data.attributes.OG_Description &&
                                data.attributes.OG_Description) ||
                                '')) ||
                        ''
                    }
                />
                <meta name="twitter:card" content="summary_large_image" />
                <link rel="canonical" href={main_domain + '/events/' + slug} />
            </Helmet>
            <div className={`page _post _event`}>
                {data && data.attributes && (
                    <div className="page__bg-wrap">
                        <div
                            className="page__bg"
                            style={{
                                backgroundImage:
                                    'url(' +
                                    ((data.attributes.Hero_background &&
                                        data.attributes.Hero_background.data &&
                                        data.attributes.Hero_background.data
                                            .attributes &&
                                        domain +
                                            data.attributes.Hero_background.data
                                                .attributes.url) ||
                                        '') +
                                    ')',
                            }}
                        ></div>
                    </div>
                )}
                <div className="page__main">
                    <div className="container">
                        {data && data.attributes && (
                            <>
                                <div className="page__entry">
                                    <div className="page__category-title">
                                        <h2>{data.attributes.Info_date}</h2>
                                    </div>
                                    {data.attributes.Title && (
                                        <div className="page__title">
                                            <h1 className="_h2">
                                                {data.attributes.Title}
                                            </h1>
                                        </div>
                                    )}
                                    <div className="page__common">
                                        <div className="page__preview"></div>
                                        <div className="page__lead">
                                            {data.attributes.Description}
                                        </div>
                                        {data.attributes.Label_img && (
                                            <div className="page__label">
                                                <img
                                                    src={
                                                        (data.attributes
                                                            .Label_img &&
                                                            data.attributes
                                                                .Label_img
                                                                .data &&
                                                            data.attributes
                                                                .Label_img.data
                                                                .attributes &&
                                                            domain +
                                                                data.attributes
                                                                    .Label_img
                                                                    .data
                                                                    .attributes
                                                                    .url) ||
                                                        ''
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}

                        <div className="page__wrap">
                            <div className="page__sidebar">
                                {data && data.attributes && (
                                    <>
                                        <ServiceCard
                                            linkType="external"
                                            link={'https://t.me/olgakoliaskina'}
                                            title={
                                                'Все вопросы по мероприятию  можно задать Ольге Коляскиной'
                                            }
                                            image={
                                                'https://api.normdubai.com/uploads/portrait_Jumeirah_2_c221d2a992.jpg'
                                            }
                                        />
                                    </>
                                )}
                            </div>

                            <div className="page__content">
                                {cards.map((components: any, index: any) => {
                                    return (
                                        <Card
                                            key={index}
                                            components={components}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {data &&
                data.attributes &&
                data.attributes.Gallery &&
                data.attributes.Gallery.data &&
                data.attributes.Gallery.data.length > 0 && (
                    <div className="section _gallery">
                        <div className="container _wide">
                            <div className="section__title">
                                <div className="_h1">
                                    {data.attributes.Title_gallery}
                                </div>
                            </div>
                            <div className="section__grid">
                                {data.attributes.Gallery.data.map(
                                    (item: any, index: any) => {
                                        console.log(item);

                                        let url = domain + item.attributes.url;

                                        return (
                                            <>
                                                {(item &&
                                                    item.attributes.mime &&
                                                    item.attributes.mime.indexOf(
                                                        'video'
                                                    ) >= 0 && (
                                                        <VideoItem
                                                            src={url}
                                                            id={
                                                                'video1_' +
                                                                index
                                                            }
                                                        />
                                                    )) || (
                                                    <div className="section__grid-item">
                                                        <img src={url} />
                                                    </div>
                                                )}
                                            </>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </div>
                )}
            {data &&
                data.attributes &&
                data.attributes.Gallery_2 &&
                data.attributes.Gallery_2.data &&
                data.attributes.Gallery_2.data.length > 0 && (
                    <div className="section _gallery">
                        <div className="container _wide">
                            <div className="section__title">
                                <div className="_h1">
                                    {data.attributes.Title_gallery_2}
                                </div>
                            </div>
                            <div className="section__grid">
                                {data.attributes.Gallery.data.map(
                                    (item: any) => {
                                        let url = domain + item.attributes.url;

                                        return (
                                            <div className="section__grid-item">
                                                <img src={url} />
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </div>
                )}
        </>
    );
};

export default Event;
